// extracted by mini-css-extract-plugin
export default {"metrics":"DetailedMetrics_metrics__Rkehy","metrics__item":"DetailedMetrics_metrics__item__KmAxM"};